<template>
  <div style="overflow-y:auto;height:100%;" class="main clearfix">
    <div class="main_middle_right">
      <router-link to="/information">用户信息收集</router-link>
      <a href="http://www.beian.miit.gov.cn" style="display:block;position: fixed;bottom: 20px;left: 50%;">冀ICP备19019941号</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  beforeCreate() {},
  mounted() {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="less" scoped>
.main {
  a {
    margin-left: 20px;
  }
  span {
    margin-left: 40px;
    cursor: pointer;
    color: #0557f3;
  }
  .main_left {
    float: left;
    width: 20%;
  }
  .main_middle {
    float: left;
    width: 20%;
  }
  .main_middle_right {
    float: left;
    width: 20%;
  }
}
</style>




// WEBPACK FOOTER //
// home.vue?4a1b0b6e